import type {RouteRecordRaw} from "vue-router";

import {EPermissao} from "@/core/type/permissao.type";

export const relatorioRoutes: RouteRecordRaw[] = [
    {
        path: "/curva-abc",
        name: "curva-abc",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_CONSULTAR_CURVA_ABC},
        component: () => import("@/modules/relatorio/pages/PageRelatorioCurvaAbc.vue")
    },
    {
        path: "/faturamento-notafiscal",
        name: "faturamento-notafiscal",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_CONSULTAR_CURVA_ABC},
        component: () => import("@/modules/relatorio/pages/PageRelatorioFaturamentoNotaFiscal.vue")
    },
];
